import { connect } from 'react-redux';
import { FLAG_ENABLE_ADVANCED_SETTINGS } from 'constants/FeatureFlags';
import SettingsModalNav from 'components/SettingsModal/SettingsModalNav';
import actions from 'actions/SettingsModal';
import { featureSelectors } from '@lifesize/nucleus';
import _get from 'lodash/get';

const mapStateToProps = (state) => ({
  showAdvancedSettings: featureSelectors.getFeatureFlag(state)(FLAG_ENABLE_ADVANCED_SETTINGS),
  showNotificationSettings: true,
  visibleTab: _get(state, 'app.settingsModal.visibleTab')
});

const mapDispatchToProps = (dispatch) => ({
  handleChangeTab: (tabName) => {
    dispatch(actions.handleChangeTab(tabName));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsModalNav);
